<div cdkDropList
     (cdkDropListDropped)="drop($event)">
  <section *ngFor="let field of value; let i = index"
           #fieldItem
           cdkDrag
           class="config-edit-area">
    <div class="short-description">
      <div class="drag-icon">
        <i class="fa-regular fa-grip-lines"></i>
      </div>
      <div class="description">
        <span><b>Title:</b></span> {{ field.title || field.fieldName || 'Untitled Field' }}
        <span><b>Visible:</b></span> {{ isFieldVisible(field) }}
      </div>
    </div>
    <div class="delete-edit-buttons"
         (click)="$event.stopPropagation()">
      <div>
        <rappider-button [icon]="getVisibilityIconConfig(isFieldVisible(field))"
                        [size]="ButtonSize.Small"
                        [tooltipText]="isFieldVisible(field) ? 'Hide field' : 'Show field'"
                        [emitWithoutPopconfirm]="true"
                        (confirm)="onVisibilityToggle(i)">
        </rappider-button>
      </div>
    </div>
  </section>
  <div *ngIf="!value || value.length === 0" class="no-fields-message">
    <p>No fields available. Add fields from form configs or grid config.</p>
  </div>
</div>

